var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showButton)?_c('v-btn',{staticClass:"white--text closeButton text-none",attrs:{"text":"","large":""},on:{"click":_vm.action}},[_c('v-icon',{staticClass:"arrow",attrs:{"large":"","color":"white","left":""}},[_vm._v("mdi-close")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }